import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { IoBagHandle } from "react-icons/io5";
import { FiTrash2 } from "react-icons/fi";
import Leftsidebar from "../sidebar/leftsidebar";
import LeftResponsivesidebar from "../sidebar/left-responsive";
import Headmenu from "../sidebar/headmenu";

// Example options
const availableSizes = ["7", "8", "9", "10", "11", "12", "48"];
const availableColors = ["Blue", "Black", "Red", "White"];

const Checkout = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([
    {
      id: 1,
      name: "CRI TRIUMPH Cricket Shoes For Men",
      image: "/image/shoeimg.png",
      originalPrice: 180,
      discountedPrice: 145,
      quantity: 1,
      size: "",
      color: "",
    },
    {
      id: 2,
      name: "CRI TRIUMPH Cricket Shoes For Men",
      image: "/image/shoeimg.png",
      originalPrice: 180,
      discountedPrice: 145,
      quantity: 1,
      size: "",
      color: "",
    },
    {
      id: 3,
      name: "CRI TRIUMPH Cricket Shoes For Men",
      image: "/image/shoeimg.png",
      originalPrice: 180,
      discountedPrice: 145,
      quantity: 1,
      size: "",
      color: "",
    },
  ]);

  // Handler functions
  const handleChange = (i, field, value) => {
    const items = [...products];
    items[i][field] = value;
    setProducts(items);
  };

  const handleQty = (i, type) => {
    const items = [...products];
    if (type === "inc") items[i].quantity += 1;
    else if (type === "dec" && items[i].quantity > 1) items[i].quantity -= 1;
    setProducts(items);
  };

  const handleRemove = (i) => {
    const items = [...products];
    items.splice(i, 1);
    setProducts(items);
  };

  const subtotal = products.reduce(
    (acc, item) => acc + item.discountedPrice * item.quantity,
    0
  );

  return (
    <div className="dashboard w-full min-h-screen flex">
      <Leftsidebar />

      <main className="flex-1 min-w-0 p-4 md:p-6 md:pl-8">
        <LeftResponsivesidebar />
        <Headmenu />
        <div className="bg-white rounded-2xl p-6 w-full mx-auto shadow-sm">
          {/* Back Button */}
          <div className="mb-6">
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="text-sm text-[#095228] font-semibold"
            >
              ← BACK
            </button>
          </div>

          {/* Main Layout */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Left: Product List */}
            <div className="lg:col-span-2 space-y-4  border rounded-xl px-3">
              {products.map((product, i) => (
                <div
                  key={product.id}
                  className="flex justify-between items-center p-4  border-b-2  "
                >
                  {/* 12% Offer badge */}

                  <div className="flex w-full items-center gap-4">
                    <div className="relative w-24 shrink-0 sm:w-1/4">
                      <img
                        src={product.image}
                        alt={product.name}
                        className="w-full max-w-[9rem] aspect-square object-contain"
                      />
                      <span className="absolute top-0 rounded-br-2xl rounded-tl-2xl bg-red-600 text-white text-[10px] sm:text-xs font-semibold px-2 py-1 rounded whitespace-nowrap">
                        12 % Offer
                      </span>
                    </div>
                    <div className="flex-1 min-w-0 sm:w-3/4">
                      <div className="flex justify-between">
                        <h3 className="text-sm font-semibold">
                          {product.name}
                        </h3>
                        <button
                          onClick={() => handleRemove(i)}
                          className=" text-red-500 text-xl"
                        >
                          <FiTrash2 />
                        </button>
                      </div>
                      {/* Dropdowns for Size and Color */}
                      <div className="flex gap-2 mt-1">
                        <select
                          value={product.size}
                          onChange={(e) =>
                            handleChange(i, "size", e.target.value)
                          }
                          className="border rounded-full px-2 py-1 text-xs"
                        >
                          <option value="">Size</option>
                          {availableSizes.map((s) => (
                            <option key={s} value={s}>
                              {s}
                            </option>
                          ))}
                        </select>
                        <select
                          value={product.color}
                          onChange={(e) =>
                            handleChange(i, "color", e.target.value)
                          }
                          className="border  rounded-full px-2 py-1 text-xs"
                        >
                          <option value="">Color</option>
                          {availableColors.map((c) => (
                            <option key={c} value={c}>
                              {c}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="text-xs text-black font-bold mt-1">
                        <p className="w-[160px] p-2 rounded-xl border-[3px] mt-3 border-green-500  text-center">
                          SKY Products Pvt Ltd.
                        </p>
                      </div>

                      <div className="flex  justify-end pt-3 items-center gap-2">
                        <p className="text-gray-400 line-through text-xs mt-1">
                          ${product.originalPrice}
                        </p>
                        <p className="text-sm font-bold text-[#095228]">
                          ${product.discountedPrice}
                        </p>
                        <div className="flex  items-center gap-2">
                          <button
                            onClick={() => handleQty(i, "dec")}
                            className="w-8 h-8 flex items-center justify-center bg-gray-200 rounded text-xl"
                          >
                            −
                          </button>
                          <span>{product.quantity}</span>
                          <button
                            onClick={() => handleQty(i, "inc")}
                            className="w-8 h-8 flex items-center justify-center bg-gray-200 rounded text-xl"
                          >
                            +
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Right: Order Summary */}
            <div className="border rounded-2xl p-6 bg-white shadow-sm h-fit">
              <h3 className="text-xl font-semibold mb-4">Order Summary</h3>
              <div className="space-y-2 text-sm">
                <div className="flex justify-between">
                  <span>Subtotal</span>
                  <span className="font-bold">${subtotal}</span>
                </div>
                <div className="flex justify-between">
                  <span>Discount</span>
                  <span className="font-bold">$15</span>
                </div>
                <div className="flex justify-between">
                  <span>Delivery Fee</span>
                  <span className="font-bold">$15</span>
                </div>
                <div className="flex justify-between">
                  <span>Tax</span>
                  <span className="font-bold">$15</span>
                </div>

                <hr />
                <div className="flex justify-between font-bold text-lg">
                  <span>Total</span>
                  <span>${subtotal + 15}</span>
                </div>
              </div>
              <button className="mt-6 w-full bg-[#095228] text-white py-3 rounded-lg font-semibold flex items-center justify-center gap-2">
                <IoBagHandle className="text-xl" />
                Pay Now
              </button>
              <p className="text-xs text-red-500 text-center mt-3">
                *Please select color and size
              </p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Checkout;
